import React from 'react'

function Connect() {
    return (
        <div className="connect center">
            <h1>Let's eat together</h1>
            <div className="connect-grid">
                <div class="connect-text">Have a great recipe ?
                <br />
                Want yourself to be featured in our weekly maagzine.
                <br />
                Connect us here.</div>
                <img src="images/eat_together.svg" alt="" />
            </div>
            <div className="footer center">
                <h2>Made with <span>❤</span> by Priyanshu </h2>
                <h2>API - Edamam</h2>
            </div>
        </div>
    )
}

export default Connect
